import { render, staticRenderFns } from "./CreateAccountWithEmail.vue?vue&type=template&id=684c9343"
import script from "./CreateAccountWithEmail.vue?vue&type=script&lang=js"
export * from "./CreateAccountWithEmail.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountWithEmail.vue?vue&type=style&index=0&id=684c9343&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports